import 'core-js/features/array/from';
import 'core-js/features/array/flat-map';
import 'core-js/features/function/name';
import 'core-js/es/symbol/index';
import 'core-js/es/symbol/iterator';
import 'core-js/features/object/assign';
import 'core-js/features/string/pad-start';
